import { Modal } from "antd";
import React, { Dispatch } from "react";
import { Translate, TranslateFunction } from "react-localize-redux";
import { useDispatch, useSelector } from "react-redux";
import { ModalErrorIcon } from "../../assets/Icons";
import { SetUnsupportedDomainVisibleAction } from "../../interfaces/store/actions/job";
import { setUnsupportedDomainVisible } from "../../store/actions/job";
import { selectIsUnsupportedDomainVisible } from "../../store/selectors/job";
import { selectTranslate } from "../../store/selectors/translate";
import { CtModalHeader } from "./CtModalHeader";
import "./CtModals.scss";

const i18nPath: string = "components.UnsupportedDomainModal.UnsupportedDomainModal";
const i18nTitle: string = `${i18nPath}.title.text`;
const i18nContent: string = `${i18nPath}.content.text`;
const i18nCloseBtn: string = `${i18nPath}.closeBtn.text`;

export const UnsupportedDomainModal = (): React.ReactElement => {
    const dispatch: Dispatch<SetUnsupportedDomainVisibleAction> = useDispatch();
    const translate: TranslateFunction = useSelector(selectTranslate);
    const visible: boolean = useSelector(selectIsUnsupportedDomainVisible);

    /**
     * Closes modal
     */
    const closeModal = (): void => {
        dispatch(setUnsupportedDomainVisible(false));
    };

    return (
        <Modal
            visible={visible}
            title={(
                <CtModalHeader
                    title={translate(i18nTitle) as string}
                    icon={<ModalErrorIcon/>}
                    className="df-ct-header-warning"
                />
            )}
            className="df-modal-primary df-ct-modal df-ct-modal-warning"
            okText={translate(i18nCloseBtn)}
            onOk={closeModal}
            closable={false}
            maskClosable={false}
        >
            <div className="df-modal-content">
                <Translate id={i18nContent}/>
            </div>
        </Modal>
    );
};
